import { render, staticRenderFns } from "./MenuHome.vue?vue&type=template&id=085ac398&scoped=true"
import script from "./MenuHome.vue?vue&type=script&lang=js"
export * from "./MenuHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085ac398",
  null
  
)

export default component.exports